import { Log } from "../../../utils";
import { ERR_INVALID_ARGUMENT } from "../../../utils/error";
/** @internal */
export function serializeLayers(pLayerManager, pContext) {
    if (pContext == null || pContext.layerNames == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    const tIOLayers = new Array();
    for (const tLayerName of pContext.layerNames) {
        let tVisible = pLayerManager._getLayers().get(tLayerName);
        if (tVisible == null) {
            tVisible = false;
            Log.warn("Unknown layer name: " + tLayerName);
        }
        const tIOLayer = {};
        tIOLayer.name = tLayerName;
        if (!tVisible)
            tIOLayer.visible = tVisible;
        tIOLayers.push(tIOLayer);
    }
    return (tIOLayers);
}
/** @internal */
export function deserializeLayers(pLayerManager, pLayers) {
    if (pLayers == null)
        return;
    for (const tIOLayer of pLayers) {
        if (tIOLayer != null) {
            let tVisible = true;
            if (tIOLayer.visible != null)
                tVisible = tIOLayer.visible;
            pLayerManager._getLayers().set(tIOLayer.name, tVisible);
        }
    }
}
